import * as a from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Basketball.es.js";
const e = a.forwardRef((o, t) => /* @__PURE__ */ a.createElement(r, { ref: t, ...o, weights: s }));
e.displayName = "BasketballIcon";
const c = e;
export {
  c as Basketball,
  e as BasketballIcon
};
